/* global yaCounter50138854 */

import scrollDepth from 'scroll-depth';
import router from './router';

function start15SecTimeout() {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter50138854) {
		yaCounter50138854.hit(path);
	}
}

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: true});
	},
});

router.on('enter', (prevState, currentState) => {
	start15SecTimeout();

	if (prevState.route && currentState.route) {
		virtualHit(currentState.route.generatePath({
			params: currentState.params,
		}));

		scrollDepth.reset();
	}
});

$(document).on('tag-drag', (e, name) => {
	ga('send', 'event', 'main', 'tag drag', clearText(name));
});

$(document).on('tag-drop', (e, name) => {
	ga('send', 'event', 'main', 'tag drop', clearText(name));
});

$(document).on('tag-click', (e, name) => {
	ga('send', 'event', 'main', 'tag click', clearText(name));
});

$(document).on('click', '.home__hash-carousel__item', (e) => {
	if ($(e.currentTarget).is('[data-router-link]')) {
		let name = $(e.currentTarget).text();

		ga('send', 'event', 'main', 'tag click', clearText(name));
	} else {
		ga('send', 'event', 'client link', 'main tag click', '#дексалгин25');
		ga('rbcspec.send', 'event', 'client link', 'click');
	}
});

$(document).on('tag-drop-dex', () => {
	ga('send', 'event', 'client link', 'main tag drop', '#дексалгин25');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$(document).on('tag-click-dex', () => {
	ga('send', 'event', 'client link', 'main tag click', '#дексалгин25');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$(document).on('click', '.home__article-previews, .home__insert__link', () => {
	ga('send', 'event', 'client link', 'main product click');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$(document).on('click', '.footer__share__list .social__item', (e) => {
	let socialName = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'main share', socialName);
});

$(document).on('click', '.article__insert', (e) => {
	let num = 1;
	let name = $(e.currentTarget).closest('.article').find('.article__title').text();

	if ($(e.currentTarget).hasClass('article__insert--2')) {
		num = 2;
	}

	ga('send', 'event', 'client link', 'article product tizer link', `${clearText(name)} || ${num}`);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$(document).on('click', '.article__share .social__item', (e) => {
	let socialName = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'article share', socialName);
});

$(document).on('click', '.article__similar__item', (e) => {
	let name = $(e.currentTarget).find('.article__similar__title').text();

	ga('send', 'event', 'article', 'see also bottom', clearText(name));
});
